import { useEffect } from "react";
import { usePatchPortfolioInvestmentMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPortfolioInvestmentMutation";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import {
	getInvestmentEditFormSchema,
	type InvestmentEditFormOutput,
} from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormSchema";
import { mapInvestmentEditFormToRequest } from "web_myplann/Portfolio/Forms/InvestmentForm/mapInvestmentFormToRequest";
import { mapPortfolioToInvestmentForm } from "web_myplann/Portfolio/Forms/InvestmentForm/mapPortfolioToInvestmentForm";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditInvestmentFormArgs = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const useEditInvestmentForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: UseEditInvestmentFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } =
		usePatchPortfolioInvestmentMutation(portfolioId);

	const { form, onSubmit, leaveConfirmation } = useEditPortfolioForm({
		schema: getInvestmentEditFormSchema(t),
		defaultValues: mapPortfolioToInvestmentForm(portfolio, t),
		mutate: (data: Partial<InvestmentEditFormOutput>, options) => {
			mutate(mapInvestmentEditFormToRequest(data, portfolio.tools), options);
		},
		successToast: t(Resources.Portfolio.EditPortfolio.savedToast, {
			type: getPortfolioTitle(portfolio, t),
		}),
		redirectTo: detailRoute,
		isPending,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending, leaveConfirmation };
};
